import React from 'react';

import '../CardSectionStyles.css';

import { loadStripe } from '@stripe/stripe-js';

import Config from '../../config.json';

const stripePromise = loadStripe(Config.stripePublishableKey);

const Stripe = ({ paymentOrder }) => {
  const handleClick = async () => {
    const stripe = await stripePromise;
    // When the customer clicks on the button, redirect them to Checkout.
    const result = await stripe.redirectToCheckout({
      sessionId: paymentOrder.sessionId,
    });
    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
    }
  };
  return (
    <>
      <button type="submit" onClick={handleClick}>
        Pay Now
      </button>
    </>
  );
};

export default Stripe;
